import React from 'react';
import messages from '../../locale/jsonMessages';
import UserLayout from '../../components/Layout/UserLayout';
import UserServicePlan from './UserServicePlan';
import { setSiteSettings } from '../../actions/siteSettings';


export default async function action({ store, params, intl }) {
    const title = intl?.formatMessage(messages.servicePlanLabel);
    // From Redux Store
    const isAuthenticated = store?.getState()?.runtime?.isAuthenticated;

    if (!isAuthenticated) {
        return { redirect: '/login' };
    }

    await store.dispatch(setSiteSettings());

    const isServicePlanEnabled = store?.getState()?.siteSettings?.data?.isServicePlanEnabled;

    if (isServicePlanEnabled == 'false') {
        return { redirect: '/user/payout' }
    }

    const mode = params.type;

    return {
        title,
        component: <UserLayout showSideMenu={'accountMenu'}><UserServicePlan mode={mode || "renter"} /></UserLayout>,
    };
};
